import { CSSProperties } from 'react';
import { borderRadius } from '../../theme/borderRadius';
import { colors } from '../../theme/colors';

export const locationIconStyles: CSSProperties = {
  color: colors.textPrimary,
};

export const locationIconContainerStyles: CSSProperties = {
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: 42,
  minHeight: 42,
  borderRadius: borderRadius.max,
};

export const locationIconContainerStylesSelected: CSSProperties = {
  ...locationIconContainerStyles,
  backgroundColor: colors.textPrimary,
};

export const locationIconContainerStylesNotSelected: CSSProperties = {
  ...locationIconContainerStyles,
  backgroundColor: colors.backgroundSuperLight,
};

export const MIN_LOCATION_ITEM_HEIGHT = 90;
